import React, { Fragment } from 'react'
import { Col, Divider, Input, Row, Select } from 'antd'
import FormItem from 'Components/FormItem'
import * as _ from 'lodash'
import { supplyChainChangeReasons } from '../../common/constants'
import { userType } from 'Common/constants'

const EditRowModalPurpose = props => {

  return (
    <Row gutter={8}>
      <Col span={24}>
        <FormItem label="Referenza">
          {props.row.refLm} - {props.row.description}
        </FormItem>
      </Col>
      <Divider />
      <Fragment>
        <Col span={12}>
          {props.tableRules.currentQuantity === 'realStock' && <FormItem label="Quantità accettata">
            <span id="quantityDefault">{props.row.acceptedStock}</span>
          </FormItem>}

          {props.tableRules.currentQuantity === 'deliveredStock' && <FormItem label="Quantità spedita">
            <span id="quantityDefault">{props.row.shippedStock}</span>
          </FormItem>}

          {props.tableRules.currentQuantity === 'withdrawnStock' && <FormItem label="Quantità effettiva">
            <span id="quantityDefault">{props.row.realStock}</span>
          </FormItem>}

          {props.tableRules.currentQuantity === 'shippedStock' && <FormItem label="Quantità da ritirare">
            <span id="quantityDefault">{props.row.withdrawnStock}</span>
          </FormItem>}
        </Col>
          {props.user.type === userType.AM.key && <Col span={12}>
              <FormItem label="Quantità effettiva">
                  <Input id="quantityReal"
                         defaultValue={props.row.realStock}
                         placeholder={props.row.realStock}
                  />
              </FormItem>
          </Col>}
        {props.user.type === userType.S.key && props.purposeState === 'APPROVED_WAITING_SUPPLIER' && <Col span={12}>
          <FormItem label="Quantità da ritirare ">
            <Input id="withdrawnStock"
                   defaultValue={props.row.withdrawnStock}
                   placeholder={props.row.acceptedStock}/>
          </FormItem>
        </Col>}
        {props.user.type === userType.SC.key && <Col span={12}>
          <FormItem label="Quantità spedita">
            <Input id="quantityShipped"
                   defaultValue={props.row.shippedStock}
                   placeholder={props.row.acceptedStock}
            />
          </FormItem>
        </Col>}
          {props.user.type === userType.S.key && props.purposeState === 'FORWARDED_SUPPLIER' && <Col span={12}>
              <FormItem label="Quantità ricevuta">
                  <Input id="quantityRecieved"
                         defaultValue={props.row.deliveredStock}
                         placeholder={props.row.acceptedStock}
                  />
              </FormItem>
          </Col>}


          { (props.user.type === userType.SC.key )  && 
              <Col span={12}>
                <Input type={'hidden'} id="supplyChangeReasonValue" value={props.row.supplyChainChangeReason}/>
          <FormItem label="Motivo Rettifica">
            <Select id="supplyChangeReasonCmb"
                    defaultValue={props.row.supplyChainChangeReason}
                    placeholder="Seleziona motivo"
                    onChange={val => {
                      document.getElementById('supplyChangeReasonValue').value = val
                    }}
                    style={{ width: '100%' }}>
              {_.map(Object.keys(supplyChainChangeReasons), index => {

                const reason = supplyChainChangeReasons[index];
                return <Select.Option key={index} value={reason.code}>{reason.label}</Select.Option>
              })}
            </Select>
          </FormItem>
        </Col>}
      </Fragment>
    </Row>
  )
}
export default EditRowModalPurpose



// WEBPACK FOOTER //
// ./src/components/EditRowModalPurpose/index.js